/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../../App.css";
import "./DoubleMatch.css";
import "../../slider.css";
import HeaderBack from "./../../components/Header/HeaderBack";
import Footer from "../../components/Footer/Footer";
import GetFullMatch from "../../components/GetProfile/GetFullMatch.js";
import Popup from "reactjs-popup";
import TimerResponse from "../../components/TimerResponse/TimerResponse";

import axios from "axios";
import { getWordByGender } from "../../handlers/dictionaryHandler.js";
import OpenSentence from "../../components/OpenSentence/OpenSentence.js";

const DoubleMatch = () => {
  const [userName, setUserName] = useState("");
  const [curMatchNew, setCurMatchNew] = useState([]);
  const [openSentence, setOpenSentence] = useState(false);

  const [messege, setMessege] = useState("");
  const [isDataLoaded, setIsDataLoaded] = useState(false);

  const [isMsgDisplayed, setIsMsgDisplayed] = useState(true);

  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  };

  useEffect(async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/doubleMatchMessege",
        config,
      );
      const userData = response.data;
      setMessege(userData.msg);
      localStorage.getItem("arriveFromPopup") == 1
        ? setIsMsgDisplayed(false)
        : setIsMsgDisplayed(true);
      if (localStorage.getItem("cntMatches") > "0") {
        setIsMsgDisplayed(true);
      }
      localStorage.setItem("arriveFromPopup", 0);
    } catch (error) {
      // probebly user is not authenticated or server is down
    }
  }, []);

  useEffect(async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_LOCALHOST_ADDRESS + "/doubleMatchesNew",
        config,
      );
      const userData = response.data.map((curMatchNew) => {
        return {
          match: curMatchNew,
          isOpen: true,
          isFullProfileOpen: false,
        };
      });
      setCurMatchNew([...userData]);
      setUserName(userData[0].match.userName);
    } catch (error) {
      // probebly user is not authenticated or server is down
    }
  }, []);

  return (
    <form className="double-match-form">
      <HeaderBack />

      <br></br>
      <div className="doublematch-body">
        <div id="h1">דאבל התאמות</div>
        <h5 style={{ textAlign: "center", marginBottom: "15px" }}>
          {userName.length > 1
            ? " הי " +
              userName +
              " " +
              getWordByGender("dear") +
              ", דאבל מצא לך התאמה! מקווים ש" +
              getWordByGender("connect") +
              " :)"
            : ""}
        </h5>

        {/* <div className="messegeMatch">{messege}</div> */}

        <Popup
          open={isMsgDisplayed}
          contentStyle={{
            maxWidth: "45%",
            borderRadius: "5px",
            direction: "rtl",
            textAlign: "center",
          }}
          position="right center"
          onClose={() =>
            // ;
            //  window.location.reload(false)
            setIsMsgDisplayed(false)
          }
          closeOnDocumentClick
          closeOnEscape
        >
          {messege}{" "}
        </Popup>

        <Popup
          open={openSentence}
          contentStyle={{
            minWidth: "30%",
            maxWidth: "70%",
            borderRadius: "5px",
          }}
          position="top center"
          onClose={() => setOpenSentence(false)}
          closeOnDocumentClick
          closeOnEscape
        >
          <div
            className="exit-popup"
            onClick={() => {
              setOpenSentence(false);
            }}
          >
            x
          </div>
          <OpenSentence />
        </Popup>

        {curMatchNew.map((pMatch) => {
          return (
            <div
              key={pMatch.match.MatchId}
              style={{ height: "auto" }}
              className="match-card-container"
            >
              <div
                className="linePlace"
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <div
                  className="rowTitle"
                  style={{
                    minWidth: "unset",
                  }}
                >
                  {pMatch.match.isEmailSent == 1
                    ? pMatch.match.details + ` ❤️ `
                    : pMatch.match.details}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ marginLeft: "0px" }}>
                    {pMatch.match.isEmailSent == 1 ? (
                      <a
                        href={
                          `https://wa.me/972` +
                          pMatch.match.otherCellular +
                          `?text=הי+${pMatch.match.otherName}+מה+נשמע+זה+${userName}+מדאבל+:)...`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div className="whatsuplink" />
                      </a>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    className={
                      pMatch.match.isEmailSent == 1 ? "lbl" : "invisible"
                    }
                    onClick={() => setOpenSentence(true)}
                  >
                    {" "}
                    <div
                      style={{
                        textDecoration: "underline",
                        fontWeight: "200",
                      }}
                    >
                      רעיונות למשפטי פתיחה :)
                    </div>
                  </div>
                </div>
              </div>
              <div className="divider" />

              <div id={`prevMatchReportArea` + pMatch.match.MatchId}>
                <GetFullMatch
                  matchId={pMatch.match.MatchId}
                  renewDate={pMatch.match.renewDate}
                  profileTitle={pMatch.match.details}
                />
              </div>
            </div>
          );
        })}
        <br />
        <div
          className="linkToFindPlace shadow"
          // className="popup_lbl lbl_link shadow"
          // style={{ color: "var(--btn-color)", background: "white" }}
        >
          <Link to="/findplace" style={{ textDecoration: "none" }}>
            {"  מקום חדש לדייט הבא שלך – " +
              getWordByGender("come") +
              " לגלות!  ⭐ "}
            {/* <div class="findplaceicon" style={{ marginTop: "-4px" }} /> */}
          </Link>
        </div>

        <Link
          to="/prevmatches"
          style={{ textDecoration: "none", marginTop: "10px" }}
        >
          <div className="prev-matches-button">התאמות קודמות</div>
        </Link>
        <Link to="/Questionnaires">
          <div
            className="back-link-minimal"
            style={{ display: "block", width: "fit-content", margin: "0 auto" }}
          >
            {" "}
            חזרה
          </div>
        </Link>

        <br />
      </div>
      <Footer />
    </form>
  );
};

export default DoubleMatch;
